import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ opacity }) => (opacity ? 2000 : -2000)};
`
